import { IOneLookLocationData } from "common/records/OneLookLocation";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_ONE_LOOK_LOCATIONS = "@oneLook/RECEIVE_ONE_LOOK_LOCATIONS";
export const SET_LOADING = "@oneLook/SET_LOADING";

export const OneLookActions = {
  receiveLocations: (locations: Partial<IOneLookLocationData>[]) => createAction(RECEIVE_ONE_LOOK_LOCATIONS, locations),
  setLoading: (loading: boolean) => createAction(SET_LOADING, loading),
};

export type OneLookActions = ActionsUnion<typeof OneLookActions>;
